<template>
    <div class="container mt-3">
        <div class="card bg-dark text-white h2 mb-3">
            <div class="card-body p-2">
                Termo de Consentimento    
            </div>
        </div>

        <az-loading v-if="$store.state.loading" />

        <div v-else-if="marcacao">

            <div v-if="$store.state.logo" style="max-height: 150px;" class="text-center mb-3">
                <img :src="$store.state.logo" alt="logo" class="logo-responsive" />
            </div>
        
            <div v-if="aceito" class="alert alert-success">
                <i class="fa fa-check-circle mr-3" aria-hidden="true"></i>
                Aceite Registrado
            </div>

            <div class="alert alert-info" v-if="marcacao">
                <div class="lead">{{ marcacao.nome_paciente }}</div>
                <div>
                    <i class="fa-solid fa-building fa-fw mr-2"></i>
                    {{ marcacao.unidade_operacao.st_nome }}
                </div>
                <div>
                    <i class="fa-solid fa-play fa-fw mr-2"></i>
                    {{ marcacao.procedimento.st_procedimento }}
                </div>
                <div>
                    <i class="fa-solid fa-user-doctor fa-fw mr-2"></i>
                    {{ marcacao.medico.st_nome_exibicao }}
                </div>
                <div>
                    <i class="fa-regular fa-calendar-days fa-fw mr-2"></i>
                    {{ $util.getFormatDate(marcacao.dt_inicio) }}
                </div>
                <div>
                    <i class="fa-regular fa-clock fa-fw mr-2"></i>
                    {{ marcacao.dt_inicio.substr(11,5) }}
                </div>
                <div>
                    <i class="fa-solid fa-location-dot fa-fw mr-2"></i>
                    {{ marcacao.unidade_operacao.endereco.exibir }}
                </div>
            </div>

            <div class="mb-3">
                <button type="button" class="btn btn-success" v-if="!aceito" :disabled="$store.state.loading" @click="registrar()">
                    <div class="spinner-border spinner-border-sm mr-2" v-if="$store.state.loading" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    Aceitar
                </button>
                <button type="button" class="btn btn-outline-danger btn-sm" v-else>Revogar Aceite</button>
            </div>

            <div class="card" v-if="termo">
                <div class="card-body">
                    <span v-html="termo"></span>
                </div>
            </div>

            <hr>

            <br><br><br><br><br>
        </div>

        <Toast :baseZIndex="99999" />
    </div>
</template>

<script>
import AzLoading from '../util/AzLoading.vue';

export default {
    data() { 
        return { 
            unidade: null, 
            termo: null,
            info: null, 
            aceito: false, 
            marcacao: null, 
        }
    }, 

    props: ['id_marcacao', 'token'],

    components: { 
        AzLoading,
    },

    methods: { 
        registrar () { 
            this.$store.commit('loading', true);

            this.axios.post('/registrar-termo-consentimento/' + window.redir, { 
                    id_marcacao: this.id_marcacao, 
                    token: this.token
                })
                .then(() => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Aceite",
                        detail: "Aceite registrado com sucesso.",
                        life: 3000
                    });

                    this.aceito = true;
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },

        load() { 
            this.$store.commit('loading', true);

            this.axios.post('/info-termo-consentimento/' + window.redir, { 
                    id_marcacao: this.id_marcacao, 
                    token: this.token
                })
                .then(response => { 
                    this.termo = response.data.termo;
                    this.aceito = response.data.aceito;
                    this.marcacao = response.data.marcacao;

                    //this.unidade = response.data.unidade
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        }
    },

    mounted() { 
        this.load();
    }
}
</script>
